import { Button } from '~/components/button';
import { TwoColumnGrid } from '~/components/layout';
import { ReviewBlock } from '~/components/review-block';
import { Title } from '~/components/typography';
import { VnmTermsContext, VnmTermsForm } from './vnm-terms.component';

export type DataEntryReviewProps = {
  context: VnmTermsContext;
  loading: boolean;
  next: (payload: VnmTermsForm) => void;
  pending: boolean;
};

export const DataEntryReview = ({ context, next }) => {
  const copy = defaultCopy;
  return (
    <TwoColumnGrid>
      <TwoColumnGrid.Primary>
        <Title>{copy.title}</Title>
        <ReviewBlock>
          <ReviewBlock.Item label="Name" notranslate>
            {`${context.firstName} ${context.lastName}`}
          </ReviewBlock.Item>
          <ReviewBlock.Item label="Email" notranslate>
            {context.email}
          </ReviewBlock.Item>
        </ReviewBlock>
        <Button mode="primary" type="submit" marginTop="24px" onClick={() => next()}>
          {copy.submitButton}
        </Button>
      </TwoColumnGrid.Primary>
    </TwoColumnGrid>
  );
};

const defaultCopy = {
  title: 'Almost there!',
  submitButton: 'Submit',
};
